import React, { FC } from 'react';

import CancelInProgressModalInterface from './CancelInProgressModalInterface';
import { Typography, ExlamationPoint, palette } from '@dev/ee-components';
import styled from 'styled-components';

const ModalContainer = styled.div`
    display: flex;
    font-size: 14px;
`;

const IconContainer = styled.div`
    margin-top: 1px;
    margin-right: 18px;
    display: inline;
`;

const CancelInProgressModal: FC<CancelInProgressModalInterface> = (props: CancelInProgressModalInterface): JSX.Element => {
    const { text } = props;
    return (
        <ModalContainer>
            <IconContainer>
                <ExlamationPoint color={`${palette.red[6]}`} />
            </IconContainer>
            <Typography variant="body1" bodyVariant="onPaper" display="inline">
                {text}
            </Typography>
        </ModalContainer>
    );
};

export default CancelInProgressModal;
